import React from "react";
import { Button } from "../components/ui/button";
import { CATALOG } from "../mock";
import { ArrowRight } from "lucide-react";

const SPOTIFY_CARD =
  "https://customer-assets.emergentagent.com/job_producer-vilas-beats/artifacts/1ymvvpfp_Screenshot%202026-06-02%20at%2014.59.25.png";

export default function Catalog({ onStart }) {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        {/* Left: heading + clickable link */}
        <div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-paul-yellow mb-6">
            {CATALOG.heading}
          </h2>
          <button
            type="button"
            onClick={onStart}
            className="inline-flex items-center gap-3 text-lg text-navy hover:text-paul-yellow transition-colors group"
          >
            <span className="w-7 h-7 rounded-full bg-paul-yellow flex items-center justify-center group-hover:scale-110 transition-transform">
              <ArrowRight className="w-4 h-4 text-white" />
            </span>
            <span className="border-b border-transparent group-hover:border-paul-yellow">
              Paul&apos;s music
            </span>
          </button>
        </div>

        {/* Right: Spotify card behind, 4 smaller covers in front */}
        <div className="relative w-full max-w-md mx-auto md:ml-auto md:mr-0 aspect-square">
          {/* Spotify Radio promo card — behind, larger, slight tilt */}
          <img
            src={SPOTIFY_CARD}
            alt="Paul Vilas on Spotify Radio"
            className="absolute top-0 right-0 w-[68%] rounded-md shadow-2xl rotate-[4deg] z-10"
            loading="lazy"
          />

          {/* 2x2 grid of smaller covers — in front, bottom-left */}
          <div className="absolute left-0 bottom-0 w-[58%] grid grid-cols-2 gap-2 z-20">
            {CATALOG.covers.slice(0, 4).map((src) => (
              <img
                key={src}
                src={src}
                alt="Album cover"
                className="w-full aspect-square object-cover rounded-sm shadow-xl"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>

      <div className="flex justify-center mt-16">
        <Button
          onClick={onStart}
          className="bg-paul-yellow hover:bg-paul-yellow text-navy font-bold px-12 py-6 text-base rounded-md shadow-md"
          style={{ color: "#0b1535" }}
        >
          Start Here
        </Button>
      </div>
    </section>
  );
}
